import React, { useState } from "react";
import { supabase } from "../../lib/supabaseClient";

// Supabase Auth Google Sign-in (2026-08) — replaces the old Emergent-managed
// broker redirect. Google OAuth now runs through C-ORE's own Google Cloud
// OAuth client (configured in Supabase Dashboard > Authentication >
// Providers > Google), so the consent screen shows C-ORE branding.
export default function GoogleButton({ testId = "google-auth-button", label = "Continue with Google", redirectPath }) {
  const [error, setError] = useState("");

  const startGoogleAuth = async () => {
    setError("");
    // 2026-11 — carries the intended post-login destination (default
    // Command Center, or a deep-linked protected route) through the full-page
    // Google OAuth redirect round-trip, since React Router state doesn't
    // survive leaving the SPA. Only set when a caller opts in (LoginPage);
    // SignupPage's "Sign up with Google" passes nothing, so the existing
    // onboarding funnel (phone/profile collection → Welcome) is unaffected.
    if (redirectPath) {
      try { sessionStorage.setItem("post_login_redirect", redirectPath); } catch (_e) { /* ignore */ }
    }
    const redirectTo = window.location.origin + "/auth/callback";
    const { error: authErr } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });
    if (authErr) setError("Google sign-in is temporarily unavailable. Please try again shortly.");
  };

  return (
    <div>
      <button
        type="button"
        data-testid={testId}
        onClick={startGoogleAuth}
        className="flex h-12 w-full items-center justify-center gap-3 rounded-full border border-slate-200 bg-white font-sans text-[15px] font-medium text-slate-700 shadow-sm transition-colors duration-150 hover:border-slate-300 hover:bg-slate-50"
      >
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.6 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.1 8.1 3l6-6C34.5 5.1 29.5 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z" />
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.9 18.9 13 24 13c3.1 0 5.9 1.1 8.1 3l6-6C34.5 5.1 29.5 3 24 3 16.3 3 9.7 7.6 6.3 14.7z" />
          <path fill="#4CAF50" d="M24 45c5.4 0 10.3-1.9 14.1-5.1l-6.6-5.4C29.5 36.5 26.9 37 24 37c-5.1 0-9.4-3.3-11.1-7.8l-6.6 5.1C9.6 40.4 16.2 45 24 45z" />
          <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.5 5.6-6.5 6.9l6.6 5.4C39.4 37.2 43 31.4 43 24c0-1.2-.1-2.3-.4-3.5z" />
        </svg>
        {label}
      </button>
      {error && (
        <p data-testid={`${testId}-error`} style={{ color: "#DC2626", fontSize: 13, marginTop: 8 }}>{error}</p>
      )}
    </div>
  );
}
